export default __webpack_public_path__ + "static/media/seating-map.4885f045.png";